import { render, staticRenderFns } from "./UniLevelBonus.vue?vue&type=template&id=345785f6&"
import script from "./UniLevelBonus.vue?vue&type=script&lang=js&"
export * from "./UniLevelBonus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports